import ISACQuestionnaireModal from './ISACQuestionnaireModal';

export default ISACQuestionnaireModal;
